"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSearchSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _MultiValueRemove = require("./components/MultiValueRemove");

var _ClearIndicator = require("./components/ClearIndicator");

var _styles = require("./styles");

var _excluded = ["theme", "styles", "showSeparator"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MultiSearchSelect = function MultiSearchSelect(props) {
  var themeProp = props.theme,
      stylesProp = props.styles,
      showSeparator = props.showSeparator,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var IndicatorSeparator = showSeparator ? _reactSelect.components.IndicatorSeparator : function () {
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, (0, _extends2.default)({
    styles: _objectSpread(_objectSpread({}, _styles.styles), stylesProp),
    theme: themeProp || (0, _styles.getTheme)(),
    isMulti: true,
    closeMenuOnSelect: false
  }, rest, {
    components: {
      IndicatorSeparator: IndicatorSeparator,
      MultiValueRemove: _MultiValueRemove.MultiValueRemove,
      ClearIndicator: _ClearIndicator.ClearIndicator
    }
  }));
};

exports.MultiSearchSelect = MultiSearchSelect;
MultiSearchSelect.propTypes = {
  showSeparator: _propTypes.bool,
  theme: _propTypes.func,
  styles: _propTypes.object,
  components: _propTypes.object
};
MultiSearchSelect.defaultProps = {
  showSeparator: false,
  theme: null,
  styles: {},
  components: {}
};